module.exports = __webpack_public_path__ + "/static/assets/11142fccab3fabab617ec3f32cc6d3cc.gif";